module.exports = "/pages/business/foodslabo/fv_points_3.png";